import Home from "./pages/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Error from "./pages/Error";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
